// Creating a new filter requires a translation under 'filters'
export enum FILTER_TYPE {
    AREA = 'AREA',
    CLIENT_TYPE = 'CLIENT_TYPE',
    BUDGET = 'BUDGET'
}
